// extracted by mini-css-extract-plugin
export var container = "FrontBanner-module--container--bxY4M";
export var slideText = "FrontBanner-module--slideText--9NL32";
export var summary = "FrontBanner-module--summary--MfBVx";
export var selected = "FrontBanner-module--selected--nl+9w";